<!--日清周结首页-->
<template>
    <div class="app-container">
        <div class="rqzj-base-container">
            <div class="event-page-container">
                <div class="head-container">
                    <div class="left-head-container" @click="backList">
                        <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </div>
                    <div class="right-head-container">{{fileForm.fileName}}</div>
                    <div class="left-head-container">
                    </div>
                </div>
                <el-scrollbar class="museum-event-info-container">
                    <iframe :src="openFileUrl" frameborder="0"
                            style="width:100%; height:calc(100vh - 150px)">

                    </iframe>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import {serviceUrl} from "@/utils/global";
import {infoFile} from "@/api/admin/fileCategory";

export default {
    name: "rqzjView",
    components: {},
    data() {
        return {
            serviceUrl,
            fileId:"",
            subject:"",
            openFileUrl:'',
            fileForm:{},
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.fileId) {
            this.fileId = this.$route.query.fileId
            this.subject = this.$route.query.subject
            this.queryFileInfo();
        }
    },
    mounted(){},
    methods: {
        queryFileInfo(){
            infoFile({fileId:this.fileId}).then((res)=>{
                if (res.data.code === 1) {
                    this.fileForm = res.data.data;
                    this.openFileUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +this.fileForm.fileUrl;

                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        backList(){
            this.$router.push({
                path: "/rqzjManager",
                query: {
                    subject: this.subject,
                }
            });
        },
    }
}
</script>
<style>
.rqzj-base-container{
    width: 100%;
    height: calc(100vh - 95px);
    background-color: #fff;
    overflow-y: auto!important;
    padding-bottom: 10px;
    padding-top: 5px;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
.event-page-container{
    width: 100%;
    height: calc(100vh - 100px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.museum-event-info-container{
    width: 100%;
    height: calc(100% - 30px)!important;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
</style>